var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workerInfo" },
    [
      _c("p", {
        domProps: { innerHTML: _vm._s(_vm.$t("workPermit.plsProvide")) },
      }),
      _vm._v(" "),
      _c("ShowNotice", {
        attrs: {
          noticeContent: _vm.NoticeOnWorkerBadgesEN,
          noticeContentCN: _vm.NoticeOnWorkerBadgesCN,
          title: _vm.$t("workPermit.noticeOnWorkerBadges"),
          expand: !_vm.isEngineer,
        },
      }),
      _vm._v(" "),
      _vm.showOperate
        ? _c("div", { staticClass: "workerInfo_operate" }, [
            !_vm.isEditing
              ? _c(
                  "button",
                  {
                    staticClass: "btn--darkblue",
                    on: { click: _vm.changeEditStatus },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.edit")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing
              ? _c(
                  "button",
                  { staticClass: "btn--orange", on: { click: _vm.save } },
                  [_vm._v(_vm._s(_vm.$t("action.save")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing
              ? _c(
                  "button",
                  { staticClass: "btn--darkblue", on: { click: _vm.cancel } },
                  [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "workerInfo_table" }, [
        _c("thead", [
          _c(
            "tr",
            _vm._l(_vm.tableHeaders, function (header, index) {
              return _c(
                "th",
                {
                  key: index,
                  on: {
                    click: function ($event) {
                      return _vm.sortTable(header)
                    },
                  },
                },
                [
                  _c("span", { class: header.className }, [
                    _vm._v(_vm._s(header.name)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "workerInfo_triangle_box" }, [
                    _vm.sortingAttr === header.attr
                      ? _c("i", {
                          class: [
                            _vm.reverse ? "triangle-down" : "triangle-up",
                          ],
                        })
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.parsedWorkInfo, function (item, index) {
            return _c(
              "tr",
              { key: item.id, on: { paste: _vm.onRowPaste } },
              [
                _c("td", { staticClass: "index" }, [
                  _vm._v("\n          " + _vm._s(index + 1) + "\n        "),
                ]),
                _vm._v(" "),
                _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                  return [
                    _c(
                      "td",
                      { key: fullnameObj.value },
                      [
                        _c("InputField", {
                          attrs: {
                            readonly: !_vm.isEditing,
                            showColon: false,
                            showFlag: _vm.isEditing,
                            value: item[fullnameObj.value],
                            required: _vm.isEditing,
                          },
                          on: {
                            updateValue: function (val) {
                              return _vm.updateField(
                                index,
                                fullnameObj.value,
                                val
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                }),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "cardNum" },
                  [
                    _c("InputField", {
                      attrs: {
                        readonly: !_vm.isEditing,
                        showColon: false,
                        showFlag: _vm.isEditing,
                        inputTip: _vm.$t("hint.inputTip.doNotOverXChars", [18]),
                        pattern: /^.{1,18}$/,
                        value: item.cardNum,
                        required: _vm.isEditing,
                      },
                      on: {
                        updateValue: function (val) {
                          return _vm.updateField(index, "cardNum", val)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "cardExpiryDate" },
                  [
                    !_vm.isEditing
                      ? _c("span", [_vm._v(_vm._s(item.cardExpiryDate))])
                      : _c("DatePicker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            format: "DD MMM YYYY",
                            clearButton: true,
                            calendarButton: true,
                            calendarButtonIcon: "fa fa-calendar",
                            value: item.cardExpiryDate,
                            disabled: { to: _vm.yesterday },
                          },
                          on: {
                            selected: function (val) {
                              return _vm.updateField(
                                index,
                                "cardExpiryDate",
                                val
                              )
                            },
                          },
                        }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "phone" },
                  [
                    _c("InputField", {
                      attrs: {
                        readonly: !_vm.isEditing,
                        showColon: false,
                        showFlag: _vm.isEditing,
                        value: item.phone,
                      },
                      on: {
                        updateValue: function (val) {
                          return _vm.updateField(index, "phone", val)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "remarks" },
                  [
                    _c("InputField", {
                      attrs: {
                        readonly: !_vm.isEditing,
                        showColon: false,
                        showFlag: _vm.isEditing,
                        value: item.remarks,
                      },
                      on: {
                        updateValue: function (val) {
                          return _vm.updateField(index, "remarks", val)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.isEditing && _vm.workerInfo.length > 1
                      ? _c("i", {
                          staticClass: "fa-times fa",
                          on: {
                            click: function ($event) {
                              return _vm.deleteWorker(index)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              2
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.isEditing
        ? _c(
            "div",
            {
              staticClass: "workerInfo_addWorker",
              on: { click: _vm.addWorkInfo },
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("workPermit.addWorker")) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "workerInfo_docs" },
        [
          _vm.canEditAttachment
            ? _c("HkldDropzone", {
                attrs: {
                  metaData: { uploadOnTop: true },
                  sourceId: _vm.docSourceId,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("EditAttachments", {
            attrs: {
              canDelete: true,
              showEditPencil: _vm.canEditDeleteDoc,
              showDeleteBtnFunc: _vm.canEditDeleteDoc,
              showAllDeleteBtn: false,
              uploadOnTop: true,
              sourceId: _vm.docSourceId,
              sortingToggle: true,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }